// Medium native cursors. Align the graphite/contact point to an integer hotspot.
const cursor = (body, x, y) => {
  const size = 18, scale = size / 32
  const hotX = Math.round(x * scale), hotY = Math.round(y * scale)
  const viewBox = `${x - hotX / scale} ${y - hotY / scale} 32 32`
  return `url("data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="${viewBox}">${body}</svg>`)}") ${hotX} ${hotY}, crosshair`
}
const pencil = 'M4 28l2-8L23 3a2 2 0 0 1 3 0l3 3a2 2 0 0 1 0 3L12 26Z'
const eraser = 'M6 25l-3-3a3 3 0 0 1 0-4L16 5a3 3 0 0 1 4 0l7 7a3 3 0 0 1 0 4l-9 9Z'
export const DRAWING_CURSORS = {
  pen: cursor(`<path d="${pencil}" fill="white" stroke="white" stroke-width="3"/><path d="${pencil}M19 7l6 6M6 20l6 6" fill="white" stroke="#171717" stroke-width="1.3"/><path d="M4 28l1-4 3 3Z" fill="#171717"/>`, 4, 28),
  eraser: cursor(`<path d="${eraser}" fill="white" stroke="white" stroke-width="3"/><path d="${eraser}M10 11l11 11M6 25h12" fill="white" stroke="#171717" stroke-width="1.3"/>`, 6, 25),
}
